import React from 'react';
import { Paper, Typography } from '@mui/material';

interface Props {
  readonly text: string;
  readonly id?: string;

  readonly elevation?: number;
}

export function SpinnerMessage({ text, id = '', elevation = 1 }: Props) {
  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 2,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        position: 'absolute',
        textAlign: 'center',
        top: 67,
        left: 0,
        right: 0,
        margin: 'auto',
        zIndex: 1000,
        maxWidth: 400,
      }}
    >
      <Typography sx={{ color: '#ffffff' }} id={id}>
        {text}
      </Typography>
    </Paper>
  );
}
